import { getDefaultWallets } from "@rainbow-me/rainbowkit";
import { configureChains, createConfig, Chain } from "wagmi";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";
import { arbitrumGoerli, bsc, polygon } from "wagmi/chains";
import {
  trustWallet,
  injectedWallet,
  rainbowWallet,
  walletConnectWallet,
  tokenPocketWallet,
  metaMaskWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { publicProvider } from "wagmi/providers/public";
import { connectorsForWallets } from "@rainbow-me/rainbowkit";

const FORK_RPC: any = process.env.VITE_FORK_RPC;
const FORK_CHAIN_ID = process.env.VITE_FORK_CHAIN_ID;
const WALLET_CONNECT_ID: any = process.env.VITE_WALLET_CONNECT_ID;

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [arbitrumGoerli, polygon, bsc],
  [
    jsonRpcProvider({
      rpc: (chain) => ({
        http: "https://rpc.buildbear.io/many-ric-olie-77c2a995",
      }),
    }),
  ]
  // [publicProvider()]
);
var projectId = "06b6b042356bff6cdb555c3c7b3c1b6b";
const connectors = connectorsForWallets([
  {
    groupName: "Recommended",
    wallets: [
      metaMaskWallet({ projectId, chains }),
      injectedWallet({ chains }),
      rainbowWallet({ projectId, chains }),
      walletConnectWallet({ projectId, chains }),
      trustWallet({
        projectId,
        chains,
      }),
      tokenPocketWallet({
        projectId,
        chains,
      }),
    ],
  },
]);

export const config = createConfig({
  autoConnect: true,
  connectors,
  publicClient,

  webSocketPublicClient,
});
export { chains };
